import type { PersonInvolvement } from "../types/involvement.js";
import type { OrganisationId } from "../types/organisation.js";
import { isInvolvementLive } from "./isInvolvementLive.js";

/**
 * The organisations that are part of this person's care at this instant,
 * holding a live involvement or behind a user who does, for whoever starts
 * involvements without being part of it themselves.
 */
export const organisationsInvolvedWithPerson = ({
  involvements,
  now = new Date(),
}: {
  involvements: readonly Pick<
    PersonInvolvement,
    "party" | "endedAt" | "expiresAt"
  >[];
  now?: Date;
}): OrganisationId[] =>
  involvements
    .filter((involvement) => isInvolvementLive(involvement, now))
    .map((involvement) =>
      involvement.party.kind === "organisation"
        ? involvement.party.organisationId
        : involvement.party.onBehalfOfOrganisationId,
    )
    .filter((organisationId) => organisationId !== null);
